import { render, staticRenderFns } from "./dealCompany.vue?vue&type=template&id=3d9c60b0&scoped=true"
import script from "./dealCompany.vue?vue&type=script&lang=js"
export * from "./dealCompany.vue?vue&type=script&lang=js"
import style0 from "./dealCompany.vue?vue&type=style&index=0&id=3d9c60b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c60b0",
  null
  
)

export default component.exports